import { Breadcrumbs, Container, Link, Stack, Typography } from "@mui/material";
import MenuMenu from "./MenuMenu";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import axios from "axios";
import { API } from "./constantsFront";
import { useEffect, useRef, useState } from "react";
import parse from 'html-react-parser';

/**
 * 利用規約・免責事項
 * @returns 
 */
const D010TermsService = () => {
  const [termsDetail, setTermsDetail] = useState("");   //利用規約・免責事項詳細
  let body = { authKey: API.API_KEY };      //2023/05/09:DBからのデータを表示するため追加
  const preview = localStorage.getItem("termspreview");
  let previewdata = JSON.parse(preview);
  localStorage.removeItem("termspreview");

  //初期表示
  const refIsFirst = useRef(true);          //2023/05/09:DBからのデータを表示するため追加
  useEffect(() => {                         //2023/05/09:DBからのデータを表示するため追加
    //初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (!previewdata) {
      //DBの内容を表示
      axios.post("/m_terms/select/publish", body).then(res => {
        let terms = res.data.terms
        setTermsDetail(parse(terms[0].content))
      })
    } else {
      //プレビュー表示
      setTermsDetail(parse(previewdata.content))
    }

    //初回読込フラグをfalseにセット
    refIsFirst.current = false;
  })

  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      利用規約・免責事項
                    </Typography>
                  </Breadcrumbs>

                  <h1>利用規約・免責事項</h1>

                  {termsDetail}


                  {/* 2023/05/09:DBからのデータを表示するためコメントアウト(FAX番号は編集時点ですでにコメントアウトされていました。) */}
                  {/* <p class="table-title">免責事項</p>
                  <div>
                    各国・地域の要件・規制は事前の周知なく変更されることがあり、本サイトに掲載している情報と異なっている場合があります。実際に輸出される際は、輸出先国・地域の輸入事業者を通じて最新の情報をご確認ください。<br />
                    <br />
                    本サイトの掲載情報の正確性については万全を期しておりますが、農林⽔産省は利⽤者が本サイトの情報を⽤いて⾏う⼀切の⾏為について何ら責任を負うものではありません。
                  </div>
                  <br />

                  <div style={{ fontWeight: "700", color: "#1B335E" }}>
                    お問い合わせ先
                  </div>
                  <div style={{ border: "1px solid #A6A8AC", padding: "10px 20px 10px 20px" }}>
                    <div style={{ fontWeight: "700", margin: "0px 0 10px 0" }}>
                    輸出・国際局輸出支援課輸出産地形成室
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{
                        backgroundColor: "#F2F3F7"
                        , color: "#1B335E"
                        , width: "100px"
                        , display: "flex"
                        , alignItems: "center"
                        , justifyContent: "center"
                      }}>
                        代表
                      </div>
                      <Stack spacing={0} direction={{ xs: 'column', md: 'row' }} style={{ marginLeft: "20px" }}>
                        <div>03-3502-8111</div>
                        <div>（内線4364）</div>
                      </Stack>
                    </div>
                    <hr style={{ margin: "10px 0 10px 0" }} />
                    <Stack spacing={2} direction={{ xs: 'column', md: 'row' }} >
                      <div style={{ display: "flex", minWidth: "50%" }} >
                        <div style={{
                          backgroundColor: "#F2F3F7"
                          , color: "#1B335E"
                          , width: "100px"
                          , textAlign: "center"
                        }}>
                          ダイヤルイン
                        </div>
                        <div style={{ marginLeft: "20px" }}>03-6738-7897</div>
                      </div> */}
                  {/* <div style={{ display: "flex" }}>
                        <div style={{
                          backgroundColor: "#F2F3F7"
                          , color: "#1B335E"
                          , width: "100px"
                          , textAlign: "center"
                        }}>
                          FAX番号
                        </div>
                        <div style={{ marginLeft: "20px" }}></div>
                      </div> */}
                  {/* </Stack> 

                  </div> */}



                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default D010TermsService;